/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCountry.ts                       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/country";

export class AutogenModelCountry<RowType extends ModelRow> extends Endpoint<RowType, RowCountryFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCountry extends ModelRow<RowCountryFields> {
	constructor(values?: Partial<RowCountryFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCountryFields {
	company_id: string;
	descr: string;
	id: string;
	is_active: string;
}

